import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function languageReducer(state: any = initialState.language, action: any) {
    switch (action.type) {
        case types.LOAD_LANGUAGE_SUCCESS: {
            return action.language;
        }
        default:
            return state;
    }
}

export const getLanguage = (state) => state.language;
